var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"fixed-bar-wrap"},_vm._l((_vm.list),function(item){return (item.url)?_c('a',{staticClass:"icon",style:(item.background),attrs:{"href":item.url,"target":"_blank"}},[_c('span',{on:{"click":function($event){return _vm.handleBury(item.channelName)}}},[_vm._v(_vm._s(item.name))])]):_vm._e()}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }